import CollapseManager from "../../js/components/collapseManager";

export default class TextDescription extends HTMLElement
{
    static get observedAttributes()
    {
        return ['stylesheet', 'translations'];
    }

    connectedCallback()
    {
        let shadowRoot = this.attachShadow({mode: 'open'});
        const t = document.querySelector('#text-description');
        const instance = t.content.cloneNode(true);

        if (
            this.translations !== undefined &&
            this.stylesheet !== undefined
        ) {
            let translations = JSON.parse(this.translations);
            this._appendChild(instance, translations);
            shadowRoot.appendChild(instance);

            new CollapseManager(shadowRoot);
        }
    }

    _appendChild(instance, translations)
    {
        if (Object.keys(translations).length > 0) {
            instance.querySelector('[name="text-description-title"]').innerHTML = translations.textDescriptionTitle;
            instance.querySelector('[name="text-description-readmore-button"]').innerHTML = translations.textDescriptionCollapseText.readMore;
            instance.querySelector('[name="text-description-readless-button"]').innerHTML = translations.textDescriptionCollapseText.readLess;

        }

        instance.querySelector('[name="stylesheet"]').href = this.stylesheet;
    }

    get stylesheet()
    {
        return this.getAttribute('stylesheet');
    }

    get translations()
    {
        return this.getAttribute('translations');
    }
}
